import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title: "Full Metal Alchemist, Vol. 1",
    price: "1676",
    rating: "4.8",
    categoryName: "Shonen",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/ki7qw7k0-0/book/p/6/a/fullmetal-alchemist-fullmetal-edition-vol-1-original-imafy239j29eb7zw.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Naruto Shippuden, Vol. 7",
    price: "747",
    rating: "4.2",
    categoryName: "Shonen",
    imgUrl: "https://rukminim1.flixcart.com/image/416/416/knhsgi80/book/8/n/y/team-7-character-naruto-shippuden-original-imag25yyyrutyyyn.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "One Piece",
    price: "900",
    rating: "4.8",
    categoryName: "Shonen",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/k0plpjk0/book/4/3/1/one-piece-vol-69-original-imafkfeaahjtyp3q.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Horimiya",
    price: "497",
    rating: "3.6",
    categoryName: "Shojo",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/kah413k0/book/9/2/0/horimiya-vol-14-original-imafsfgrd2guuqvm.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Berserk, Vol. 1",
    price: "1128",
    rating: "5",
    categoryName: "Seinen",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/jpu324w0/book/2/0/5/berserk-volume-1-the-black-swordsman-original-imafbzjetu6w2vf9.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Prison School",
    price: "999",
    rating: "5.0",
    categoryName: "Comedy",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/kkr72q80/book/k/9/k/prison-school-vol-4-original-imagyfbvmhjhwszz.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Fruits Basket",
    price: "700",
    rating: "4.8",
    categoryName: "Shojo",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/kkmwr680/book/7/s/n/fruits-basket-collector-s-edition-vol-1-original-imafzyfqxphgeudz.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Monster",
    price: "1656",
    rating: "5",
    categoryName: "Seinen",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/kiew3gw0-0/book/k/k/n/monster-the-perfect-edition-vol-3-original-imafy7zfss8fexyq.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "One Punch Man, Vol. 17",
    price: "845",
    rating: "4.6",
    categoryName: "Sci-fi",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/k47cgi80/book/6/4/2/one-punch-man-vol-1-original-imaf8w2azyyf6vwg.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Inuyashiki.",
    price: "447",
    rating: "3.9",
    categoryName: "Sci-fi",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/kjvrdzk0/book/j/j/p/inuyashiki-7-original-imafzcy2qxgxuztq.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Attack on Titan, Vol. 3",
    price: "856",
    rating: "5.0",
    categoryName: "Fantasy",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/k0cqqvk0/book/0/9/9/attack-on-titan-character-encyclopedia-original-imafk6eeftchx2j6.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "The Way of the househusband, Vol. 3",
    price: "1028",
    rating: "3.9",
    categoryName: "Comedy",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/k5y7tzk0/book/4/6/2/the-way-of-the-househusband-vol-3-original-imafzgj3gwtaysd9.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Spy X Family",
    price: "914",
    rating: "4",
    categoryName: "Comedy",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/k5o7r0w0/book/4/6/6/spy-x-family-vol-1-original-imafzbyhpmazw5yk.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Haikyuu!, Vol. 1",
    price: "799",
    rating: "4.6",
    categoryName: "Sports manga",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/jpfsnm80/book/6/6/0/haikyu-vol-1-original-imafbnwpnz74fet2.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Demon Slayer",
    price: "927",
    rating: "4.9",
    categoryName: "Fantasy",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/k6fd47k0/book/5/5/2/demon-slayer-kimetsu-no-yaiba-vol-10-original-imafnddw9ze2yv6j.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Dragon Ball Z",
    price: "897",
    rating: "4.8",
    categoryName: "Shonen",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/kh0vonk0/book/1/9/9/dragonball-z-coloring-book-original-imafx4rbcyqe3zde.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Great Teacher Onizuka",
    price: "947",
    rating: "4.7",
    categoryName: "Comedy",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/jbfe7ww0-1/book/6/3/6/gto-14-days-in-shonan-volume-9-original-imafybv6y7ueghyn.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Ao Haru Ride, Vol. 6",
    price: "802",
    rating: "5",
    categoryName: "Shojo",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/kirr24w0-0/book/u/w/v/ao-haru-ride-vol-8-original-imafyhd3knen9dg4.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Kuroko's Basketball, Vol. 1",
    price: "674",
    rating: "4.7",
    categoryName: "Sports manga",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/kjx6tu80/book/d/r/8/kuroko-s-basketball-vol-11-original-imafzd2zb3dfgfsa.jpeg?q=70"
  },
  {
    _id: uuid(),
    title: "Made in Abyss",
    price: "374",
    rating: "3.7",
    categoryName: "Sci-fi",
    imgUrl: "https://rukminim1.flixcart.com/image/612/612/k0jvy4w0/book/7/3/5/made-in-abyss-voi-1-original-imafkbh2qgfvxwja.jpeg?q=70"
  }
];
